export default __webpack_public_path__ + "img/it-security-compliance.0ebbcb3c.png";